

export default getImportSummary;
import resolveId from '../resolveId';
function getImportSummary(_ref) {
	var imports = _ref.imports;
	var absolutePaths = _ref.absolutePaths;
	var name = _ref.name;

	var paths = [];
	var names = [];
	var seen = {};
	var placeholders = 0;

	imports.forEach(function (x) {
		var path = x.id || x.path; // TODO unify these

		if (!seen[path]) {
			seen[path] = true;

			paths.push(path);

			// TODO x could be an external module, or an internal one.
			// they have different shapes, resulting in the confusing
			// code below
			if (x.needsDefault || x.needsNamed || x.specifiers && x.specifiers.length) {
				while (placeholders) {
					names.push('__dep' + names.length + '__');
					placeholders--;
				}
				names.push(x.name);
			} else {
				placeholders++;
			}
		}
	});

	var ids = absolutePaths ? paths.map(function (relativePath) {
		return resolveId(relativePath, name);
	}) : paths.slice();

	return { ids: ids, paths: paths, names: names };
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/amd/getImportSummary.js.01-babel.map